module.exports = __webpack_public_path__ + "img/contact-icon.c078498b.svg";